import _ from "lodash";
var menuActive = false;
var callbacks = [];

function toggleState(state) {
    setState(state || !menuActive);
    return menuActive;
}
function getState() {
    return menuActive;
}
function setState(state) {
    menuActive = state;
    _.each(callbacks, function (callback) {
        callback(menuActive);
    });
    return menuActive;
}
function onChange(callback) {
    callbacks.push(callback);
}

function MobileMenuService() {
    return {
        toggle: toggleState,
        get: getState,
        set: setState,
        onChange: onChange
    };
}

export default MobileMenuService;
